import { Helmet } from "react-helmet-async";
import SectionHeader from "../components/SectionHeader";

export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you. Your enquiry has been captured. Connect this form to your API to save/send enquiries.");
  };

  return (
    <main className="page-top section-padding">
      <Helmet><title>Contact | VRGlobal Tech</title></Helmet>
      <div className="container">
        <SectionHeader eyebrow="Contact" title="Tell us about your project" text="Send your requirement for ERP, website, SEO, domain, server or social media ads." />
        <div className="row g-4 mt-3">
          <div className="col-lg-5">
            <div className="contact-card h-100">
              <h4>Contact Details</h4>
              <p><i className="bi bi-envelope me-2"></i> info@vrglobal.com</p>
              <p><i className="bi bi-globe me-2"></i> vrglobal.com</p>
              <p><i className="bi bi-geo-alt me-2"></i> India</p>
              <hr />
              <p className="text-soft mb-0">Share your business requirement and we will suggest the best technical solution.</p>
            </div>
          </div>
          <div className="col-lg-7">
            <form className="contact-card" onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6"><label className="form-label">Name</label><input className="form-control" required /></div>
                <div className="col-md-6"><label className="form-label">Email</label><input type="email" className="form-control" required /></div>
                <div className="col-md-6"><label className="form-label">Phone</label><input className="form-control" /></div>
                <div className="col-md-6">
                  <label className="form-label">Service</label>
                  <select className="form-select"><option>ERP Application</option><option>SEO</option><option>Domain Registration</option><option>Servers & Hosting</option><option>Social Media Ads</option><option>Website Development</option></select>
                </div>
                <div className="col-12"><label className="form-label">Message</label><textarea className="form-control" rows="5" required></textarea></div>
                <div className="col-12"><button className="btn btn-brand btn-lg w-100">Submit Enquiry</button></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}
